module.exports = __webpack_public_path__ + "img/user-shield-duotone.a2adef4f.svg";